import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { IOptionsDropDown } from '../../models/DropDown';
import { BadgeService } from '../../services/badge-service.service';

@Component({
  selector: 'dropdown-autocomplete',
  templateUrl: './dropdown-autocomplete.component.html',
  styleUrls: ['./dropdown-autocomplete.component.scss'],
})
export class DropdownAutocompleteComponent implements OnInit, OnDestroy {

  @Input() options: IOptionsDropDown = { array: [{ descripcion: '' }] };

  public search = '';

  private finishSubscriptions: Subject<boolean> = new Subject();

  constructor(
    private popoverC: PopoverController
    , private searchS: BadgeService
  ) { }

  ngOnInit() {
    this.searchS.searchState
      .pipe(takeUntil(this.finishSubscriptions))
      .subscribe(x => this.search = x)
  }

  ngOnDestroy() {
    this.finishSubscriptions.next(true);
    this.finishSubscriptions.complete();
  }

  public onSelect = (item: string) => this.popoverC.dismiss({ item });

}
